import gql from 'graphql-tag'

export const GetConversation = gql`
    query GetConversation($conversation: ConversationWhereUniqueInput!) {
        conversation(where: $conversation) {
            id
            title
            parent {
                id
                type
                parent
            }
            author {
                id
                display
                oauthId
                picture
            }
            bookmarkedBy {
                id
                oauthId
                display
            }
            participants {
                id
                oauthId
                display
            }
            unreadMessagesBy {
                id
                oauthId
                display
            }
            createdAt
            # comments(where: { parentComment: null }) {
            #     ...CommentsRecursive
            # }
            comments {
                ...CommentFields
            }
        }
    }
       
    fragment CommentFields on Comment {
        __typename
        id
        content
        ancestorCommentIds
        parentConversation {
            __typename
            id
        }
        parentComment {
            __typename
            id
        }
        author {
            __typename
            id
            display
            oauthId
            picture
        }
        createdAt
        bookmarkedBy {
            __typename
            id
            display
            oauthId
            picture
        }
        likedBy {
            __typename
            id
            display
            oauthId
            picture
        }
        dislikedBy {
            __typename
            id
            display
            oauthId
            picture
        }
        attachments {
            __typename
            id
            name
            createdAt
            mediaType
        }
    }
`
export const GetConversationParticipantsButAuthor = gql`
    query GetConversationParticipantsButAuthor(
        $conversationId: ID!
        $commentCreatorOauthId: String!
    ) {
        conversation(where: { id: $conversationId }) {
            id
            participants(where: { NOT: { oauthId: $commentCreatorOauthId } }) {
                id
                oauthId
            }
        }
    }
`
